import{useChatApi as e}from"./use-chat-api.hook.js";const s=()=>{const s=e(),{deleteMessage:t}=s;return{deleteMessage:t}};export{s as useChatDeleteMessage};